import { Box, Text } from '@factorialco/deprecated-design-system'

import type Company from 'modules/core/store/models/Company'

import { additionalCompensationLabels } from 'modules/bookkeepers/lib/dynamicTranslations'
import type {
  CompensationField,
  CompensationValueModifier,
  IncidenceChangeValue,
} from 'modules/payroll_bundle/lib/types'

const modifyValue = (
  field: string,
  company: Company,
  legalEntityId?: string,
  changeValue?: IncidenceChangeValue,
  valueModifier?: CompensationValueModifier
) => {
  if (valueModifier) {
    return valueModifier(company, legalEntityId, changeValue)
  }

  return changeValue ? changeValue[field] : null
}

export interface Props {
  compensationField: CompensationField
  previousValue?: IncidenceChangeValue
  currentValue: IncidenceChangeValue
  company: Company
  legalEntityId?: string
  deleted: boolean
}

const Item = ({
  compensationField,
  previousValue,
  currentValue,
  company,
  legalEntityId,
  deleted = false,
}: Props) => {
  const { field, translation_key, value_modifier } = compensationField

  const modifiedPreviousValue = modifyValue(
    field,
    company,
    legalEntityId,
    previousValue,
    value_modifier
  )

  const modifiedCurrentValue = modifyValue(
    field,
    company,
    legalEntityId,
    currentValue,
    value_modifier
  )

  const isEqual = modifiedPreviousValue === modifiedCurrentValue

  if ((!modifiedCurrentValue && !modifiedPreviousValue) || (isEqual && !deleted)) return null

  return (
    <Box gap="s8" flexDirection="row" key={field}>
      <Box flexNoShrink paddingLeft="s8">
        <ul style={{ listStyle: 'inside' }}>
          <li>
            <Text.Normal weight="normal" size="200" color="grey800">
              {`${additionalCompensationLabels(translation_key)}:`}
            </Text.Normal>
          </li>
        </ul>
      </Box>
      <Text.Normal size="200" weight="medium" color="grey800">
        {!!modifiedPreviousValue && !deleted && (
          <>
            <Text.Normal weight="normal" size="200" color="grey700">
              <del>{modifiedPreviousValue}</del>
            </Text.Normal>
            →{' '}
          </>
        )}
        {deleted ? <del>{modifiedCurrentValue}</del> : modifiedCurrentValue}
      </Text.Normal>
    </Box>
  )
}

export default Item
